import React from 'react'
import { connect } from 'react-redux'
import { Modal, Input, message, Icon, Button, Form } from 'antd'

import { push } from 'react-router-redux'
import { store } from '../../store/store.js'

import './style.css'
import LayoutWrapper from '../../layouts/LayoutWrapper'
import DynamicForm from '../../components/frame/DynamicForm'
import DynamicTable from '../../components/frame/DynamicTable'
import DynamicButton from '../../components/frame/DynamicButton'
import DynamicFilter from '../../components/frame/DynamicFilter'
import ReactAbstract from '../../components/abstract/React.abstract'
import {
  fetchEmployeesList
} from '../../actions/employee-management-actions'
import {
  fetchDepartmentsList
} from '../../actions/department-structure-actions'
import {
  changeSalaryLedger,
  selectSalaryLedger
  // updateSalaryLedger,
} from '../../actions/salary-allowance-actions'
import salaryLedgerService
  from '../../services/SalaryAllowance/salary-ledger-service'


class SalaryLedgerDetail extends ReactAbstract {

  // initReload = false
  // moduleName = "salaryAllowance"
  // childModuleName = "salaryLedger"
  dataMode = 1
  deleteRowSelection = true
  childModuleName = 'salaryLedger'

  state = {
    currentModalStatus: false,
    importContractModal: false,
    currentIndex: null,
    currentData: {},
    currentDataStatus: 'unload',
    filters: {
      modelId: this.props.routing.location.pathname.split('/')[3]
    },
    data: [],
    dataStatus: 'unload',
    delivery: false
  }

  actions = {
    selectAction: salaryLedgerService.detailSalaryLedger,
    updateAction: salaryLedgerService.updateSalaryLedger,
    exportAction: salaryLedgerService.exportSalaryLedger
  }

  headerColumn = [{
    title: '后退',
    icon: 'arrow-left',
    type: 'default',
    click: () => store.dispatch(push('/salary-allowance/salary-ledger'))
  }, {
    title: '初始化薪资台账',
    icon: 'plus-circle-o',
    access: 'initiate_value',
    click: () => this.publicHandle({
      alert: true,
      title: '初始化薪资台账(初始化后您之前手动录入的数据会清空)',
      data: {
        salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3]
      },
      callee: salaryLedgerService.initiaSalaryLedger,
      callback: this.publicChange
    })
  }, {
    title: '薪资计算',
    icon: 'plus-circle-o',
    access: 'cal_att_value',
    click: () => this.publicHandle({
      alert: true,
      title: '进行薪资计算',
      data: {
        salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3]
      },
      callee: salaryLedgerService.caculateSalaryLedger,
      callback: (this.publicChange)
    })
  },
    //  {
    // 	title: "发工资条",
    // 	icon: "plus-circle-o",
    // 	access: "send_salary_record_value",
    // 	click: () => this.publicHandle({
    // 		alert: true,
    // 		title: "发工资条",
    // 		data: {
    // 			salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3]
    // 		},
    // 		//callee: salaryLedgerService.multiSalaryLedger,
    // 		callee: salaryLedgerService.initiaSalaryLedger,
    // 		callback: this.publicChange
    // 	})
    // },
    {
      title: '发工资条',
      icon: 'plus-circle-o',
      access: 'monthly_audit_value',
      click: () => this.publicHandle({
        alert: true,
        title: '发工资条',
        data: {
          salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3]
        },
        callee: salaryLedgerService.checkSalaryLedger,
        callback: this.publicChange
      })
    },
    {
      title: '工资条导入',
      access: 'export_value',
      icon: 'plus-circle-o',
      click: () => this.setState({ importModalStatus: true })
    },
    {
      title: '导出',
      access: 'export_value',
      icon: 'cloud-download-o',
      click: this.publicExport
    },
    // {
    // 	title: "课时费导入",
    // 	access: "export_value",
    // 	icon: "cloud-upload-o",
    // 	click: this.openImportContractModal.bind(this)
    // },
    {
      title: '差异表导出',
      access: 'export_value',
      icon: 'cloud-download-o',
      click: () => {
        this.differenceExport()
      }
    }
  ]

  filterColumn = [{
    type: 'person'
  }, {
    type: 'department'
  }, {
    type: 'radio',
    key: 'job_status',
    children: [
      { id: '', text: '全部' },
      { id: '1', text: '在职' },
      { id: '5', text: '离职' }
    ]
  }
  ]

  tableColumn = [
    {
      title: '工号',
      dataIndex: 'job_number',
      key: 'job_number',
      className: 'table-global-head-small',
      fixed: 'left'
    },
    //  {
    // 	title: '中文名',
    // 	dataIndex: 'employee_name',
    // 	key: 'employee_name',
    // 	className: 'table-global-head',
    // 	fixed: 'left',
    // },
    {
      title: '证件姓名',
      dataIndex: 'id_name',
      key: 'id_name',
      className: 'table-global-head',
      fixed: 'left'
    },
    // {
    // 	title: '英文名',
    // 	dataIndex: 'english_name',
    // 	key: 'english_name',
    // 	className: 'table-global-head',
    // 	fixed: 'left',
    // },
    {
      title: '校区',
      dataIndex: 'campus',
      key: 'campus',
      className: 'table-global-head'

    }, {
      title: '部门名称',
      dataIndex: 'department_name',
      key: 'department_name',
      className: 'table-global-head'
    },
    //  {
    // 	title: '国籍',
    // 	dataIndex: 'nationality_name',
    // 	key: 'nationality_name',
    // 	className: 'table-global-head-small'
    // },
    {
      title: '基本工资',
      dataIndex: 'current_base_salary',
      key: 'current_base_salary',
      className: 'table-global-head-short'
    }, {
      title: '岗位工资',
      dataIndex: 'current_post_salary',
      key: 'current_post_salary',
      className: 'table-global-head-short'
    }, {
      title: '基础保障工资',
      dataIndex: 'current_guarantee_salary',
      key: 'current_guarantee_salary',
      className: 'table-global-head-short'
    }, {
      title: '缴纳单位',
      dataIndex: 'pay_unit',
      key: 'pay_unit',
      className: 'table-global-head-short'
    }, {
      title: '补贴',
      dataIndex: 'welfare_subsidies',
      key: 'welfare_subsidies',
      className: 'table-global-head-short'
    }, {
      title: '固定津贴',
      dataIndex: 'fixed_allowance',
      key: 'fixed_allowance',
      className: 'table-global-head-short'
    },
    {
      title: '其他补贴',
      dataIndex: 'subsidy',
      key: 'subsidy',
      className: 'table-global-head-short'
    }, {
      title: '课时费',
      dataIndex: 'class_hour_fee',
      key: 'class_hour_fee',
      className: 'table-global-head-short'
    }, {
      title: '全勤奖',
      dataIndex: 'allowance',
      key: 'allowance',
      className: 'table-global-head-short'
    }, {
      title: '业绩是否达成',
      dataIndex: 'is_deliver_results',
      key: 'is_deliver_results',
      className: 'table-global-head-6x',
      render: text => text ? '是' : '否'
    }, {
      title: '事假',
      dataIndex: 'leave_subsidies',
      key: 'leave_subsidies',
      className: 'table-global-head-small'
    }, {
      title: '绩效-事假',
      dataIndex: 'leave_subsidies',
      key: 'leave_subsidies',
      className: 'table-global-head-small',
      render: (text, record) => record.base_percent ? (record.leave_subsidies * record.base_percent).toFixed(2) : record.leave_subsidies
    }, {
      title: '事假(小时)',
      dataIndex: 'personal_leave_hours',
      key: 'personal_leave_hours',
      className: 'table-global-head-short'
    }, {
      title: '病假',
      dataIndex: 'sick_leave_subsidies',
      key: 'sick_leave_subsidies',
      className: 'table-global-head-small'
    },{
			title: '绩效-病假',
			dataIndex: 'sick_leave_subsidies',
			key: 'sick_leave_subsidies',
			className: 'table-global-head-small',
			render: (text, record) => record.base_percent ? (record.sick_leave_subsidies * record.base_percent).toFixed(2) : record.sick_leave_subsidies
		},  {
      title: '病假(小时)',
      dataIndex: 'sick_leave_hours',
      key: 'sick_leave_hours',
      className: 'table-global-head-short'
    }, {
      title: '其他假期',
      dataIndex: 'other_holidays',
      key: 'other_holidays',
      className: 'table-global-head-short'
    }, {
      title: '未打卡扣款',
      dataIndex: 'not_punched_deduct',
      key: 'not_punched_deduct',
      className: 'table-global-head-6x'
    }, {
      title: '迟到早退扣款',
      dataIndex: 'come_late_deduct',
      key: 'come_late_deduct',
      className: 'table-global-head-short'
    },{
			title: '绩效-迟到早退扣款',
			dataIndex: 'come_late_deduct',
			key: 'come_late_deduct',
			className: 'table-global-head-small',
			render: (text, record) => record.base_percent ? (record.come_late_deduct * record.base_percent).toFixed(2) : record.come_late_deduct
		},  {
      title: '旷工扣款',
      dataIndex: 'stay_away_deduct',
      key: 'stay_away_deduct',
      className: 'table-global-head-short'
    },{
			title: '绩效-旷工扣款',
			dataIndex: 'stay_away_deduct',
			key: 'stay_away_deduct',
			className: 'table-global-head-small',
			render: (text, record) => record.base_percent ? (record.stay_away_deduct * record.base_percent).toFixed(2) : record.stay_away_deduct
		}, {
      title: '本期收入',
      dataIndex: 'current_income',
      key: 'current_income',
      className: 'table-global-head-short'
    },
    {
      title: '应发工资',
      dataIndex: 'wage_payable',
      key: 'wage_payable',
      className: 'table-global-head-short'
    }, {
      title: '代扣个税',
      dataIndex: 'withholding_tax',
      key: 'withholding_tax',
      className: 'table-global-head-short'
    },
    //  {
    // 	title: '个人养老费',
    // 	dataIndex: 'pension_rates_personal',
    // 	key: 'pension_rates_personal',
    // 	className: 'table-global-head-6x'
    // }, {
    // 	title: '个人医疗费',
    // 	dataIndex: 'medical_rates_personal',
    // 	key: 'medical_rates_personal',
    // 	className: 'table-global-head-6x'
    // }, {
    // 	title: '个人失业费',
    // 	dataIndex: 'unemployment_rates_personal',
    // 	key: 'unemployment_rates_personal',
    // 	className: 'table-global-head-6x'
    // },
    {
      title: '社保个人',
      dataIndex: 'social_securitys_personal',
      key: 'social_securitys_personal',
      className: 'table-global-head-6x'
    },
    {
      title: '公积金个人',
      dataIndex: 'provident_fund_rates_personal',
      key: 'provident_fund_rates_personal',
      className: 'table-global-head-6x'
    },
    {
      title: '其他',
      dataIndex: 'invoice_tax_deduct',
      key: 'invoice_tax_deduct',
      className: 'table-global-head-short'
    },
    {
      title: '实发工资',
      dataIndex: 'real_wages',
      key: 'real_wages',
      className: 'table-global-head-short'
    }, {
      title: '子女教育支出',
      dataIndex: 'children_education',
      key: 'children_education',
      className: 'table-global-head-6x'
    }, {
      title: '继续教育支出',
      dataIndex: 'adult_education',
      key: 'adult_education',
      className: 'table-global-head-6x'
    }, {
      title: '住房贷款利息支出',
      dataIndex: 'home_loan_interest',
      key: 'home_loan_interest',
      className: 'table-global-head-8x'
    }, {
      title: '住房租金支出',
      dataIndex: 'housing_rents',
      key: 'housing_rents',
      className: 'table-global-head-6x'
    }, {
      title: '赡养老人支出',
      dataIndex: 'support_the_old',
      key: 'support_the_old',
      className: 'table-global-head-6x'
    }, {
      title: '专项总计',
      dataIndex: 'special_total',
      key: 'special_total',
      className: 'table-global-head-6x'
    }, {
      title: '现金',
      dataIndex: 'cash',
      key: 'cash',
      className: 'table-global-head-small'
    }, {
      title: '代发工资银行1',
      dataIndex: 'payroll_bank',
      key: 'payroll_bank',
      className: 'table-global-head-6x'
    }, {
      title: '银行2',
      dataIndex: 'bank',
      key: 'bank',
      className: 'table-global-head-6x'
    }, {
      title: '银行3',
      dataIndex: 'bank2',
      key: 'bank2',
      className: 'table-global-head-6x'
    },
    {
      title: '劳保健',
      dataIndex: 'laobaojian',
      key: 'laobaojian',
      className: 'table-global-head-short'
    }, {
      title: '税后扣款',
      dataIndex: 'post_tax_deduct',
      key: 'post_tax_deduct',
      className: 'table-global-head-short'
    },
    {
      title: '审核状态',
      dataIndex: 'review_str',
      key: 'review_str',
      className: 'table-global-head-short'
    }, {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      className: 'table-global-head-6x',
      render: (text, record, index) => (
        <DynamicButton column={this.buttonColumn(text, record, index)}
                       module={this.childModuleName}
                       access={this.props.access}/>
      )
    }
  ]
  deliveryTableColumn = [
    {
      title: '工号',
      dataIndex: 'job_number',
      key: 'job_number',
      className: 'table-global-head-small'
    }, {
      title: '中文名',
      dataIndex: 'real_name',
      key: 'real_name',
      className: 'table-global-head'
    }, {
      title: '英文名',
      dataIndex: 'english_name',
      key: 'english_name',
      className: 'table-global-head'
    }, {
      title: '部门',
      dataIndex: 'department_name',
      key: 'department_name',
      className: 'table-global-head'
    }, {
      title: '基础保障薪资',
      dataIndex: 'guarantee_salary',
      key: 'guarantee_salary',
      className: 'table-global-head'
    }
  ]

  buttonColumn = (text, record, index) => [{
    size: 'small',
    type: 'default',
    icon: 'edit',
    title: '编辑',
    access: 'u_value',
    click: this.updateData.bind(this, record, index)
  }, {
    size: 'small',
    type: 'default',
    icon: 'edit',
    title: '补发工资条',
    access: 'resend_salary_record_value',
    click: () => this.publicHandle({
      alert: true,
      title: '补发工资条',
      data: {
        id: record.id
      },
      callee: salaryLedgerService.selectSalaryLedger,
      callback: this.publicChange
    })
  }, {
    size: 'small',
    type: 'default',
    icon: 'calculator',
    title: '计算薪资',
    access: 'u_value',
    click: () => this.publicHandle({
      alert: true,
      title: '计算薪资',
      data: {
        modelId: record.id
      },
      callee: salaryLedgerService.calcSingleSalary,
      callback: this.publicChange
    })
  }
  ]

  formColumn = () => [{
    label: '员工姓名',
    key: 'employee_name',
    type: 'text'
  }, {
    label: '部门名称',
    key: 'department_name',
    type: 'text'
  }, {
    label: '基本工资',
    key: 'current_base_salary',
    type: 'text'
  }, {
    label: '岗位工资',
    key: 'current_post_salary',
    type: 'text'
  }, {
    label: '',
    type: 'title'
  }, {
    label: '事假扣款',
    key: 'leave_subsidies',
    type: 'number',
    required: false
  }, {
    label: '病假扣款',
    key: 'sick_leave_subsidies',
    type: 'number',
    required: false
  }, {
    label: '其他假期',
    key: 'other_holidays',
    type: 'number',
    required: false
  }, {
    label: '未打卡扣款',
    key: 'not_punched_deduct',
    type: 'number',
    required: false
  }, {
    label: '迟到早退扣款',
    key: 'come_late_deduct',
    type: 'number',
    required: false
  }, {
    label: '旷工扣款',
    key: 'stay_away_deduct',
    type: 'number',
    required: false
  }, {
    label: '课时费',
    key: 'class_hour_fee',
    type: 'number',
    required: false
  }, {
    label: '全勤奖',
    key: 'allowance',
    type: 'number',
    required: false
  }, {
    label: '补贴',
    key: 'welfare_subsidies',
    type: 'number',
    required: false
  }, {
    label: '固定津贴',
    key: 'fixed_allowance',
    type: 'number',
    required: false
  }, {
    label: '其他补贴',
    key: 'subsidy',
    type: 'number',
    required: false
  },
    {
      label: '其他',
      key: 'invoice_tax_deduct',
      type: 'number',
      required: false
    },
    {
      label: '税后扣款',
      key: 'post_tax_deduct',
      type: 'number',
      required: false
    }, {
      label: '现金',
      key: 'cash',
      type: 'number',
      required: false
    }, {
      label: '劳保健',
      key: 'laobaojian',
      type: 'number',
      required: false
    },
    {
      label: '子女教育支出',
      key: 'children_education',
      type: 'number',
      required: false
    },
    {
      label: '继续教育支出',
      key: 'adult_education',
      type: 'number',
      required: false
    },
    {
      label: '住房贷款利息支出',
      key: 'home_loan_interest',
      type: 'number',
      required: false
    },
    {
      label: '住房租金支出',
      key: 'housing_rents',
      type: 'number',
      required: false
    },
    {
      label: '赡养老人支出',
      key: 'support_the_old',
      type: 'number',
      required: false
    },

    {
      label: '业绩是否达成',
      key: 'is_deliver_results',
      type: 'checkbox',
      children: [
        { id: true, text: '是' },
        { id: false, text: '否' }
      ]

    }
  ]

  customComponentWillMount() {
    this.props.fetchDepartmentsList()

    //加载未设定业绩是否达成的人员
    this.fetchNeedSettingDeliveryEmployees()

  }

  //加载未设定业绩是否达成的人员
  fetchNeedSettingDeliveryEmployees = () => {
    salaryLedgerService.fetchNeedSettingDeliveryEmployees({ account_month_id: this.props.routing.location.pathname.split('/')[3] }, res => {
      if (res.data.length > 0) {
        this.setState({
          delivery: true,
          deliveryDataStatus: 'loaded',
          deliveryData: res.data
        })
      }
    })
  }


  updateData = (record, index) => this.setState({
    currentData: this.dataSource().data.Data[index],
    currentModalStatus: true,
    currentDataStatus: 'loaded',
    currentIndex: index
  })

  differenceExport = () => {
    let ref = Modal.info({
      content: '正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！'
    })
    salaryLedgerService.differenceExport({ salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3] }, res => {
      ref.destroy()
      if (res.data.Success) {
        window.open(res.data.Message)
      } else {
        message.error('导出数据失败, ' + res.data.Errors[0], 4)
      }
    }, err => message.error('导出数据失败, 请联系管理员', 4))
  }

  calcSingleSalary = (record) => {
    salaryLedgerService.calcSingleSalary({
      employee_id: record.employee_id,
      salaryaccount_monthly_id: this.props.routing.location.pathname.split('/')[3]
    }, res => {
      if (res.data.Success) {
        message.success('计算成功，' + res.data.Message, 4)
        this.publicSelect()
      } else {
        message.error('计算失败, ' + res.data.Errors[0], 4)
      }
    }, err => message.error('计算失败', 4))
  }

  openImportContractModal() {
    this.setState({ importContractModal: true })
  }

  closeImportContractModal() {
    this.setState({ importContractModal: false })
  }

  setUploadedFile = event => {
    this.setState({ uploadedFile: event.target.files[0] })
  }
  uploadFile = () => {
    if (this.state.uploadedFile) {
      let ref = Modal.info({ content: '正在导入文件, 请稍后...' })
      let formData = new FormData()
      formData.append('uploadedFile', this.state.uploadedFile)
      salaryLedgerService.import(formData, res => {
        ref.destroy()
        if (res.data.Success) {
          message.success('导入文件成功，' + res.data.Message, 4)
          this.setState({
            importModal: false,
            dataStatus: 'unload'
          })
          this.publicSelect()
          if (res.data.Object) {
            window.open(res.data.Object)
          }
        } else {
          message.error('导入文件失败, ' + res.data.Errors[0], 4)
        }
      }, err => message.error('导入文件失败', 4))
    } else {
      message.error('请选择需要导入的文件', 4)
    }
  }

  downloadTemplate = () => {
    let ref = Modal.info({ content: '正在准备需要下载的模板' })
    salaryLedgerService.downloadTemplate(res => {
      ref.destroy()
      if (res.data.Success) {
        window.open(res.data.Message)
      }
    })
  }

  //确认达成业绩
  confirmDelivery = () => {
    Modal.confirm({
      title: '确定选择的员工达成业绩么?',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        salaryLedgerService.settingDeliveryEmployees({
          account_month_id: this.props.routing.location.pathname.split('/')[3],
          ids: this.state.selectedIDs
        }, res => {
          if (res.data.Success) {
            message.success('操作成功', 4)
            this.setState({ delivery: false })
          } else {
            message.error('操作失败' + res.data.Errors[0], 4)
          }
        })

      },
      onCancel: () => {
      }
    })
  }
  toggleDeliveryModal = () => window.history.go(-1)
  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {

      let ids = selectedRows.map(row => row.id)
      this.setState({ selectedIDs: ids })
    }
  }


  render() {
    return (
      <div className="app-module-item">
        <div className="app-module-header">
          <DynamicButton column={this.headerColumn}
                         module={this.childModuleName}
                         access={this.props.access}/>
          <DynamicFilter column={this.filterColumn}
                         departmentsList={this.props.departmentStructure.departmentsList}
                         value={this.state.filters}
                         setFilter={this.publicChange}/>
        </div>
        <Modal width="1000px"
               visible={this.state.currentModalStatus}
               title="薪资台账"
               destroyOnClose={true}
               onCancel={this.toggleCurrentModal}
               onOk={this.publicSubmit}>
          <DynamicForm column={this.formColumn}
                       form={this.props.form}
                       loadStatus={this.state.currentDataStatus}
                       dataSource={this.state.currentData}/>
        </Modal>
        <Modal width="900px"
               visible={this.state.importContractModal}
               title="课时费导入"
               destroyOnClose={true}
               onCancel={this.closeImportContractModal.bind(this)}
               footer={<Button type="back" onClick={this.closeImportContractModal.bind(this)}>关闭</Button>}>
          <div style={{ textAlign: 'center', margin: '20px 0px 20px' }}>
            <div>
              <Button type="primary" onClick={this.downloadTemplate}>
                <Icon type="cloud-download-o"/>
                <span>下载模板</span>
              </Button>
            </div>
            <div style={{ marginTop: '40px' }}>
              <div>导入文件</div>
              <Input type="file" style={{ height: '38px' }} onChange={this.setUploadedFile}/>
              <Button type="primary" style={{ marginTop: '20px' }} onClick={this.uploadFile}>
                <Icon type="cloud-upload-o"/>
                <span>开始导入</span>
              </Button>
            </div>
          </div>
        </Modal>

        <Modal width="800px"
               visible={this.state.importModalStatus}
               title="导入薪资"
               destroyOnClose={true}
               onCancel={() => this.setState({ importModalStatus: false })}
               footer={<Button type="back"
                               onClick={() => this.setState({ importModalStatus: false })}>关闭</Button>}>
          <div style={{ textAlign: 'center', margin: '20px 0px 20px' }}>
            <div>
              <Button type="primary" onClick={this.downloadTemplate}>
                <Icon type="cloud-download-o"/>
                <span>下载模板</span>
              </Button>
            </div>
            <div style={{ marginTop: '40px' }}>
              <div>导入文件</div>
              <Input type="file" style={{ height: '38px' }} onChange={this.setUploadedFile}/>
              <Button type="primary" style={{ marginTop: '20px' }} onClick={this.uploadFile}>
                <Icon type="cloud-upload-o"/>
                <span>开始导入</span>
              </Button>
            </div>
          </div>
        </Modal>
        {/* 业绩是否达成选择 */}
        <Modal width="1000px"
               maskClo sable={false}
               visible={this.state.delivery}
               title="业绩达成选择"
               destroyOnClose={true}
               closable={false}
               footer={<Button type="back" onClick={this.toggleDeliveryModal}>关闭</Button>}>
          <div className="app-module-item">
            <div className="app-module-header">
              <div className="colAction"
                   style={{ float: 'left', margin: '0px 10px 10px 0px' }}>
                <Button type="primary" size="default" onClick={this.confirmDelivery}>
                  <span>确认达成业绩</span>
                </Button>
              </div>
            </div>
            <div>
              <DynamicTable column={this.deliveryTableColumn}
                            dataStatus={this.dataSource().deliveryDataStatus}
                            dataSource={this.dataSource().deliveryData}
                            pagination={false}
                            rowSelection={this.rowSelection}/>
            </div>
          </div>
        </Modal>

        <div>
          <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                          total: this.dataSource().data.Total,
                          pageSize: this.dataSource().data.PageSize,
                          current: this.dataSource().filters.page
                        }}
                        rowSelection={this.rowSelection}
                        setPageFilter={this.publicChange}
                        scrollx={6050}/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    salaryAllowance: state.salaryAllowance,
    employeeManagement: state.employeeManagement,
    departmentStructure: state.departmentStructure,
    routing: state.routing
  }
}

const mapDispatchToProps = {
  fetchEmployeesList,
  fetchDepartmentsList,
  changeSalaryLedger,
  selectSalaryLedger
}

SalaryLedgerDetail = Form.create()(SalaryLedgerDetail)

SalaryLedgerDetail = connect(mapStateToProps, mapDispatchToProps)(SalaryLedgerDetail)

export default LayoutWrapper(SalaryLedgerDetail)





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryLedgerDetail.js